import PolicyBanner from './PolicyBanner';

export default PolicyBanner;
export { policyRailColor } from './utils';
